module.exports = __webpack_public_path__ + "img/modal-report.5836fb50.png";